var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_68415)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58051 4.10877C3.28762 4.40167 3.28762 4.87654 3.58051 5.16943C3.8734 5.46233 4.34828 5.46233 4.64117 5.16943L7.99994 1.81066L11.3535 5.16423C11.6464 5.45712 12.1213 5.45712 12.4142 5.16423C12.7071 4.87133 12.7071 4.39646 12.4142 4.10357L8.53027 0.219669C8.23738 -0.0732234 7.7625 -0.0732228 7.46961 0.21967L3.58051 4.10877ZM12.4194 11.8912C12.7123 11.5983 12.7123 11.1235 12.4194 10.8306C12.1265 10.5377 11.6516 10.5377 11.3587 10.8306L7.99994 14.1894L4.64641 10.8358C4.35352 10.5429 3.87864 10.5429 3.58575 10.8358C3.29286 11.1287 3.29286 11.6036 3.58575 11.8965L7.46961 15.7804C7.61026 15.921 7.80103 16 7.99994 16C8.19885 16 8.38962 15.921 8.53027 15.7804L12.4194 11.8912Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_68415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron-up-down.501d70574a34cf3020b41a61c5ef5634.svg";
export { ForwardRef as ReactComponent };